import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import {routerReducer, routerMiddleware} from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';

import navigation from './reducers/navigation';
import panier from "./reducers/panier";

const initialState = {};

export const history = createHistory();

const middleware = [
  applyMiddleware(routerMiddleware(history))
];

export const store = createStore(
    combineReducers({navigation, panier, router: routerReducer}),
    initialState,
    compose(...middleware)
);
